module.exports = __webpack_public_path__ + "img/xinisno.3a62ac4e.png";